import { Button, Typography } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { keyframes } from "styled-components";

const bounceIn = keyframes`
  0% {
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
  }
  30% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  50% {
    opacity: 1;
    transform: scale3d(0.95, 0.95, 0.95);
  }
  70% {
    transform: scale3d(1.02, 1.02, 1.02);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;

export const AddressSectionAnimation = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  gap: ${({ theme }) => theme.spacings.xs};

  animation: ${bounceIn} 1s ease both;
`;

export const ResponsiveContainer = styled.div`
  height: 100%;
  width: 100%;
  min-height: 0;

  padding: ${({ theme }) => theme.spacings.m} 0;
  display: grid;
  gap: ${({ theme }) => theme.spacings.xs};
  grid-template-columns:
    [full-start] repeat(1, 1fr)
    [content-start] repeat(6, 1fr)
    [content-end] repeat(1, 1fr)
    [full-end];

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(8, 1fr);
  }
`;

export const Grid = styled.div`
  height: 100%;
  min-height: 0;
  max-height: 100%;
  width: 100%;

  display: grid;
  grid-column: content-start / content-end;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  align-items: stretch;
  align-content: stretch;

  gap: ${({ theme }) => theme.spacings.xs4};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-column: 1 / -1;
    grid-template-columns: repeat(6, 1fr);
  }
`;

export const LeftSection = styled.div`
  grid-column: 1 / span 4;

  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: 1 / -1;
  }
`;

export const RightSection = styled.div`
  grid-column: 5 / span 2;

  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: 1 / -1;
  }
`;

export const AcceptTermsLabel = styled(Typography)`
  & button {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.brand[50]};
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`;

export const AddMembersButton = styled(Button)`
  border-color: ${({ theme }) => theme.colors.secondary[95]} !important;
  background-color: ${({ theme }) => theme.colors.secondary[95]} !important;
  border-radius: ${({ theme }) => theme.borders.radius.pill} !important;
  width: 100% !important;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary[90]} !important;
  }
`;

export const HelperText = styled.p`
  margin: ${({ theme }) => theme.spacings.xs5} 0 0
    ${({ theme }) => theme.spacings.xs2};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral[50]};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xs5};
  fill: transparent;
`;
